module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/path-to-regexp/~/isarray/index.js
// module id = 4125
// module chunks = 168707334958949